// Conquistas: progresso por categoria, título e moldura do perfil.
import { api, errorMessage, type AchievementsResponse } from "../api";
import { num, t, type MsgKey } from "../i18n";
import type { View } from "../router";
import { loadSession } from "../session";
import { esc, screen } from "../ui";
import { PDX } from "./market";

const CATS = ["jornada", "colecao", "habilidade", "secreta"] as const;
const ICON: Record<string, string> = { jornada: "🧭", colecao: "📘", habilidade: "⚔️", secreta: "❔" };

export const achievementsView: View = (root) => {
  root.innerHTML = screen(t("ach.title"), "/menu", `<div class="bw-textbox">${t("common.loading")}</div>`);
  const body = root.querySelector<HTMLElement>(".screen__body")!;
  let data: AchievementsResponse | null = null;

  const render = (alert?: { msg: string; kind: string }) => {
    const d = data!;
    const done = d.achievements.filter((a) => a.unlockedAt).length;
    body.innerHTML = `
      <section class="bw-panel ach-summary">
        <div><b class="ach-count">${done}/${d.achievements.length}</b><br><span class="bw-dim small">${t("ach.unlocked")}</span></div>
        <label class="ach-pick">${t("ach.titleLabel")}
          <select class="bw-input" data-title>
            <option value="">${t("ach.none")}</option>
            ${d.titles.map((x) => `<option ${d.equipped.title === x ? "selected" : ""}>${esc(x)}</option>`).join("")}
          </select></label>
        <label class="ach-pick">${t("ach.frameLabel")}
          <select class="bw-input" data-frame>
            <option value="">${t("ach.none")}</option>
            ${d.frames.map((x) => `<option value="${esc(x)}" ${d.equipped.frame === x ? "selected" : ""}>${esc(t(`ach.frame.${x}` as MsgKey))}</option>`).join("")}
          </select></label>
      </section>
      ${alert ? `<div class="bw-alert bw-alert--${alert.kind}">${esc(alert.msg)}</div>` : ""}
      ${CATS.map((cat) => {
        const list = d.achievements.filter((a) => a.category === cat);
        return `<section class="bw-panel bw-stack">
          <div class="bw-panel__header">${ICON[cat]} ${t(`ach.cat.${cat}` as MsgKey)} <span class="bw-dim small">${list.filter((a) => a.unlockedAt).length}/${list.length}</span></div>
          <ul class="ach-list">${list.map((a) => {
            const pct = Math.round((Math.min(a.progress, a.goal) / a.goal) * 100);
            const name = a.secret ? t("ach.secretName") : t(`ach.${a.id}.name` as MsgKey);
            const desc = a.secret ? t("ach.secretDesc") : t(`ach.${a.id}.desc` as MsgKey, { n: a.goal });
            const reward = [a.reward.pokedollars ? `${PDX} ${num(a.reward.pokedollars)}` : "", a.reward.title ? `«${esc(a.reward.title)}»` : "", a.reward.frame ? t("ach.frameReward") : ""].filter(Boolean).join(" · ");
            return `<li class="ach ${a.unlockedAt ? "done" : ""} ${a.isNew ? "new" : ""}">
              <span class="ach-medal" aria-hidden="true">${a.unlockedAt ? "🏅" : a.secret ? "❔" : "○"}</span>
              <div class="ach-main"><b>${esc(name)}</b>${a.isNew ? ` <span class="board-badge new-badge">${t("changelog.new")}</span>` : ""}<br>
                <span class="small">${esc(desc)}</span>
                ${!a.unlockedAt && a.goal > 1 ? `<div class="pet-bar__track"><div class="pet-bar__fill" style="width:${pct}%"></div></div><span class="bw-dim small">${num(a.progress)}/${num(a.goal)}</span>` : ""}
              </div>
              <span class="ach-reward small">${a.secret ? "?" : reward}</span>
            </li>`;
          }).join("")}</ul>
        </section>`;
      }).join("")}`;
  };

  async function load(alert?: { msg: string; kind: string }) {
    try {
      data = await api.achievements();
      if (data.fresh.length) void loadSession();
      render(alert);
    } catch (e) {
      body.innerHTML = `<div class="bw-alert bw-alert--error">${esc(errorMessage(e))}</div>`;
    }
  }

  body.addEventListener("change", async (e) => {
    const el = e.target as HTMLSelectElement;
    try {
      if (el.hasAttribute("data-title")) await api.setTitle(el.value || null);
      if (el.hasAttribute("data-frame")) await api.setFrame(el.value || null);
      void loadSession();
      await load({ msg: t("ach.saved"), kind: "ok" });
    } catch (err) {
      await load({ msg: errorMessage(err), kind: "error" });
    }
  });
  void load();
};
